@if (hide) {
  <div class="login-card">
    <div class="login-card__header">
      <div class="login-card__header-icon"><mat-icon>point_of_sale</mat-icon></div>
      <div class="login-card__header-text">
        <h2>Nova Point</h2>
        <p>Welcome back. Please login to continue.</p>
      </div>
      <button mat-icon-button class="login-card__close" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-tab-group class="login-tabs">
      @for (loginType of ['email','phone', 'nin']; track loginType) {
        <mat-tab>
          <ng-template matTabLabel>
            {{ loginType | translate}}
          </ng-template>
          @if (loginType === 'email') {
            <form (ngSubmit)="login()" [formGroup]="staffLoginForm" autocomplete="off" novalidate class="login-card__body">
              <mat-form-field appearance="outline" class="login-field">
                <mat-label>{{'email' | translate}}</mat-label>
                <input formControlName="username" matInput [type]="loginType === 'email' ? 'email': 'text'">
                <mat-icon matSuffix>email</mat-icon>
                <mat-error>
                  @if (!staffLoginForm.get('username').valid && staffLoginForm.get('username').touched) {
                    <span>{{'field-is-required' | translate}}</span>
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="login-field">
                <mat-label>{{'password' | translate}}</mat-label>
                <input formControlName="password" matInput [type]="showPassword ? 'text' : 'password'">
                <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
                  <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error>
                  @if (!staffLoginForm.get('password').valid && staffLoginForm.get('password').touched) {
                    <span>{{'field-is-required' | translate}}</span>
                  }
                </mat-error>
              </mat-form-field>

              <button [disabled]="!staffLoginForm.valid || loading" type="submit" class="login-submit-btn">
                @if (loading) {
                  <mat-icon class="login-submit-btn__spinner">autorenew</mat-icon>
                } @else {
                  <mat-icon>login</mat-icon>
                }
                {{'login' | translate}}
              </button>

              <div class="login-card__row">
                <button (click)="close()" type="button" class="login-card__link">
                  {{'cancel' | translate}}
                </button>
                <button (click)="toggleLoginPassword()" type="button" class="login-card__link login-card__link--accent">
                  {{'forgot-password' | translate}}
                </button>
              </div>
            </form>
          } @else {
            <div class="login-card__upcoming">
              <mat-icon svgIcon="password-reset"></mat-icon>
              <p>
                This feature is currently in development and will be released shortly. You will be informed upon its completion.
              </p>
            </div>
          }
        </mat-tab>
      }
    </mat-tab-group>
  </div>
}


@if (!hide) {
  <div class="login-card">
    <div class="login-card__header">
      <div class="login-card__header-icon"><mat-icon>lock_reset</mat-icon></div>
      <div class="login-card__header-text">
        <h2>{{ 'reset-password' | translate}}</h2>
        <p>We'll email you a link to reset it.</p>
      </div>
    </div>

    <form (ngSubmit)="submitResetPassword(resetPwdForm.value)" [formGroup]="resetPwdForm" class="login-card__body">
      <mat-form-field appearance="outline" class="login-field">
        <mat-label>{{ 'email' | translate}}</mat-label>
        <input formControlName="email" matInput type="email">
        <mat-icon matSuffix>email</mat-icon>
        <mat-error>
          @if (!resetPwdForm.get('email').valid && resetPwdForm.get('email').touched) {
            <span>{{'field-is-required' | translate}}</span>
          }
        </mat-error>
      </mat-form-field>

      <button [disabled]="!resetPwdForm.valid || loading" type="submit" class="login-submit-btn">
        <mat-icon>send</mat-icon>
        {{'send-reset-link' | translate}}
      </button>

      <div class="login-card__row login-card__row--center">
        <button (click)="toggleLoginPassword()" type="button" class="login-card__link">
          {{ 'go-back' | translate}}
        </button>
      </div>
    </form>
  </div>
}
